module.exports = __webpack_public_path__ + "static/media/project-monitoring.fe6e138b.webp";